import { StyleSheet } from "@react-pdf/renderer"

export const styles = StyleSheet.create({
	page: {
		backgroundColor: "#fff",
		fontFamily: "Helvetica",
		fontSize: 12,
		paddingVertical: 40,
		paddingHorizontal: 60,
	},
	section: {
		paddingTop: 20,
	},
	grid: {
		flexDirection: "row",
		justifyContent: "space-between",
		marginTop: 20,
		marginBottom: 30,
		padding: 20,
		paddingLeft: 0,
		paddingRight: 0,
		backgroundColor: "#f9f9f9",
	},
	sectionLeft: {
		paddingRight: 10,
		width: 220,
	},
	sectionRight: {
		paddingLeft: 25,
		width: 220,
	},
	h1: {
		fontSize: 16,
		marginBottom: 20,
		color: "#1B1464",
	},
	h2: {
		fontSize: 13,
		marginBottom: 15,
		color: "#1B1464",
	},
	p: {
		fontSize: 10,
		marginBottom: 13,
	},
	image: {
		width: 220,
		marginBottom: 10,
	},
	bottomPage: {
		marginTop: 30,
	},
})
